module.exports = window.initializeRemote('alerts');